import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AccordionProps,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '../_base/Typography';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type VibAccordionProps = Omit<AccordionProps, 'title'> & {
  title: ReactNode;
  withBorder?: boolean;
  contentClassName?: string;
  summaryClassName?: string;
};

export const VibAccordion = (props: VibAccordionProps) => {
  const {
    expanded,
    onChange,
    title,
    children,
    withBorder = false,
    contentClassName,
    summaryClassName,
    className,
    ...restProps
  } = props;

  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      disableGutters
      className={twMerge(
        withBorder
          ? 'border border-solid border-grayDivider rounded-default shadow-none'
          : 'shadow-small',
        className,
      )}
      sx={{ ':before': { display: 'none' } }}
      {...restProps}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={summaryClassName}
      >
        {typeof title === 'string' ? (
          <Typography component="h6">{title}</Typography>
        ) : (
          title
        )}
      </AccordionSummary>
      <AccordionDetails className={contentClassName || 'p-main'}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
